// @flow
import React, { Component } from 'react';
import {
  TooltipContentDiv,
  TooltipContentP
  // CloseIcon
} from './TooltipContentStyles';

type Props = {
  message: string,
  mobileRightEdge?: boolean,
  direction: string,
  className?: string
};

export default class TooltipContent extends Component<Props> {
  static defaultProps = {
    direction: 'up'
  };
  render() {
    return (
      <TooltipContentDiv
        mobileRightEdge={this.props.mobileRightEdge}
        direction={this.props.direction}
        className={this.props.className}
      >
        <TooltipContentP>{this.props.message}</TooltipContentP>
        {/* <CloseIcon name="x" colorName="black" /> */}
      </TooltipContentDiv>
    );
  }
}
